import { useState } from "react";
import {
  Card,
  Upload,
  Button,
  Alert,
  Table,
  Row,
  Col,
  Statistic,
  Tag,
  message,
} from "antd";
import {
  UploadOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
import api from "../api/api";

export default function CargaUsuariosCsv() {
  const [loading, setLoading] = useState(false);
  const [responseApi, setResponseApi] = useState(null);

  const handleUpload = async ({ file }) => {
    const formData = new FormData();
    formData.append("file", file);

    setLoading(true);
    setResponseApi(null);

    try {
      const res = await api.post("/api/AdduserEbookEcommerceCsv", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      setResponseApi(res.data);
      message.success("Archivo procesado correctamente");
    } catch (error) {
      message.error("Error al procesar el archivo CSV");
    } finally {
      setLoading(false);
    }
  };

  const getAlertType = () => {
    if (!responseApi) return "info";
    if (responseApi.ok > 0 && responseApi.error === 0) return "success";
    if (responseApi.ok > 0 && responseApi.error > 0) return "warning";
    return "error";
  };

  return (
    <Card title="Carga masiva de usuarios eBooks (CSV)">
      <Upload accept=".csv" customRequest={handleUpload} showUploadList={false}>
        <Button icon={<UploadOutlined />} type="primary" loading={loading}>
          Cargar archivo CSV
        </Button>
      </Upload>

      {responseApi && (
        <>
          {/* 🔔 ALERTA RESUMEN */}
          <Alert
            style={{ marginTop: 24 }}
            type={getAlertType()}
            showIcon
            message="Resultado del procesamiento"
            description={
              <Row gutter={16}>
                <Col span={8}>
                  <Statistic
                    title="Registros procesados"
                    value={responseApi.procesados}
                  />
                </Col>
                <Col span={8}>
                  <Statistic
                    title="Creados correctamente"
                    value={responseApi.ok}
                    valueStyle={{ color: "#3f8600" }}
                    prefix={<CheckCircleOutlined />}
                  />
                </Col>
                <Col span={8}>
                  <Statistic
                    title="Con error"
                    value={responseApi.error}
                    valueStyle={{ color: "#cf1322" }}
                    prefix={<CloseCircleOutlined />}
                  />
                </Col>
              </Row>
            }
          />

          {/* ❌ TABLA DE ERRORES */}
          {responseApi.errores?.length > 0 && (
            <Table
              style={{ marginTop: 24 }}
              bordered
              size="small"
              pagination={false}
              rowKey="fila"
              dataSource={responseApi.errores}
              columns={[
                {
                  title: "Fila",
                  dataIndex: "fila",
                  width: 80,
                  align: "center",
                },
                {
                  title: "Email",
                  dataIndex: "email",
                },
                {
                  title: "Detalle del error",
                  dataIndex: "error",
                  render: (text) => <Tag color="red">{text}</Tag>,
                },
              ]}
            />
          )}
        </>
      )}
    </Card>
  );
}
